import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, Button, message, Row, Spin } from 'antd';
import styled from 'styled-components';
import AppLayout from '../../../common/components/layout';
import useHttpHelper from '../../../common/hooks/useHttpHelper';
import { appLinks, appRoutes, queryKeys } from '../../../config/constants';
import ClubForm from '../common/createEdit';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { get } from 'lodash';

const ContainerDiv = styled.div`
background-color: white;
padding-left: 24px;
padding-top: 24px;
`;

const initialValues = { isActive: true }

export default () => {

  const navigate = useNavigate();

  const { httpPostAsync } = useHttpHelper();

  const createClubAsync = async (data) => {
    //const link = appLinks.createNewPerons
    // console.log('accept challenge link', link);
    console.log('club post data', data);
    const createPersonData = { ...data };
    const response = await httpPostAsync(appLinks.createClub, createPersonData);
    console.log('create club async', response);

    return response;
  };

  const mutationQueryKey = [queryKeys.createNewPerson]

  const {
    //data: createPersonResponse,
    isLoading: isCreating,
    mutateAsync: onCreateClubAsync,
  } = useMutation(
    createClubAsync,
    { mutationKey: mutationQueryKey, }
  );


  const onSubmit = async (postData, redirect = false) => {
    try {

      console.log('postData', postData);

      const response = await onCreateClubAsync(postData);

      if (response && response.code === 0) {
        message.success('Club was created successfully');

        if (redirect) {
          // save and continue, => redirect to challenges listing
          navigate(`/${appRoutes.clubs}`);
        } else {
           //save/create new => created new and redirect to edit
          const clubId = get(response, 'data.id');
          if (clubId > 0) {
             navigate(`/${appRoutes.editClub}/${clubId}`)
          }
        }
       
      } else if (response && response.code === 0) {
        message.error('Club could not be created')
      }

    } catch (error) {
      console.log('error submitting', error);
    }
  }

  const onBack = () => {
    try {

      navigate(`/${appRoutes.clubs}`);

    } catch (error) {
      console.log('error on back click', error);
    }
  }


  return (
    <AppLayout activeItem='clubs'>
      <Spin spinning={isCreating}>
        <Row align="middle" style={{paddingBottom:8}} >
          <Button onClick={onBack} shape="circle" icon={<ArrowLeftOutlined />} />
          <Breadcrumb style={{ margin: 8, marginLeft: 12 }} >
            <Breadcrumb.Item><a onClick={onBack}>Clubs</a></Breadcrumb.Item>
            <Breadcrumb.Item>New Club</Breadcrumb.Item>
          </Breadcrumb>
        </Row>
        <ContainerDiv>
          <ClubForm
            formValues={initialValues}
            onSubmit={onSubmit}
            submitTitle='Save'
          />
        </ContainerDiv>
      </Spin>
    </AppLayout>
  );

}